import type { OptionKV } from "~styled/selector/Selector";

export enum EEstadoSiniestro {
  Ingresado = "Ingresado",
  PendienteCompania = "PendienteCompania",
  Resuelto = "Resuelto",
  Rechazado = "Rechazado",
}

export const INGRESADO = EEstadoSiniestro.Ingresado;
export const PENDIENTE_COMPANIA = EEstadoSiniestro.PendienteCompania;
export const RESUELTO = EEstadoSiniestro.Resuelto;
export const RECHAZADO = EEstadoSiniestro.Rechazado;

const estadoSiniestrosOptions: Record<EEstadoSiniestro, string> = {
  [INGRESADO]: "Ingresado",
  [PENDIENTE_COMPANIA]: "Pendiente en Compañía",
  [RESUELTO]: "Resuelto",
  [RECHAZADO]: "Rechazado",
};

const estadoSiniestrosFilter: OptionKV<EEstadoSiniestro>[] = [
  { label: estadoSiniestrosOptions[INGRESADO], value: INGRESADO },
  {
    label: estadoSiniestrosOptions[PENDIENTE_COMPANIA],
    value: PENDIENTE_COMPANIA,
  },
  { label: estadoSiniestrosOptions[RESUELTO], value: RESUELTO },
  { label: estadoSiniestrosOptions[RECHAZADO], value: RECHAZADO },
];

export { estadoSiniestrosOptions, estadoSiniestrosFilter };
